import doctorsModalTemplateUrl from './modals/doctor.ngtemplate.html';
import patientsModalTemplateUrl from './modals/patient.ngtemplate.html';
import _ from 'lodash';
import stampit from 'stampit';

const componentName = 'telesurvey';
const serviceName = 'TelesurveyRealtimeComponent';
const moduleName = 'doxy.realtime.components.telesurvey';

export { componentName, serviceName, moduleName };

export default angular
  .module(moduleName, [])
  .factory(
    'TelesurveyRealtimeComponent',
    function (
      $rootScope,
      $window,
      $modal,
      RealtimeComponent,
      pn,
      apiUrl,
      $sce,
      notificationFactory,
      $timeout
    ) {
      const doctorsScope = $rootScope.$new();
      let patientsModal;
      let doctorsModal;
      let responseForm;

      function getDoctorUuid() {
        return _.get(pn.people.getDoctors(), '0.uuid');
      }

      return stampit({
        deepProps: {
          name: 'Telesurvey',
          componentName: 'telesurvey',
          respondSent: false,
          events: {
            request: 'onRequest',
            respond: 'onResponse',
          },
        },
        methods: {
          open({ peopleAvailable }) {
            doctorsScope.form = { url: '' };
            doctorsScope.status = 'start';
            doctorsScope.patients = peopleAvailable.getPatients();

            doctorsScope.shareTo = (patient) => {
              if (!doctorsScope.form.url.trim()) {
                return;
              }

              if (patient.isUndetermined) {
                notificationFactory.showCommon(
                  'error',
                  'undetermined-person-in-extension'
                );
                return;
              }

              const matches = doctorsScope.form.url.match(
                'https://redcap.musc.edu/surveys/(index.php)?\\?s=(\\w+)'
              );

              if (!matches) {
                notificationFactory.showCommon(
                  'warning',
                  'Only MUSC REDCap URLs are supported'
                );
                doctorsScope.form.url = '';
                return;
              }

              doctorsScope.status = 'filling';
              doctorsScope.fillingUsername = _.get(patient, 'state.username');

              const surveyUrl =
                apiUrl + '/redcap/surveys/index.php?s=' + matches[2];
              this.sendTo(patient.uuid, 'request', { url: surveyUrl });
            };

            doctorsModal = $modal({
              scope: doctorsScope,
              contentTemplate: doctorsModalTemplateUrl,
            });
          },

          onRequest(message) {
            const onSubmit = this.onFormSubmit.bind(this);
            $window.addEventListener('message', onSubmit, false);
            this.respondSent = false;
            const scope = $rootScope.$new();
            scope.url = $sce.trustAsResourceUrl(message.url);

            scope.status = 'filling';
            scope.height = 150;
            $window.addEventListener(
              'message',
              function (event) {
                const origin = event.origin || event.originalEvent.origin;
                const action = _.get(event, 'data.action');
                const height = _.get(event, 'data.height');
                const status = _.get(event, 'data.status');

                if (action !== 'doxyme-redcap' || origin !== apiUrl) {
                  return;
                }

                if (status) {
                  scope.status = status;
                }

                const iframeHeight = window.innerHeight - 150;
                if (height) {
                  scope.height = iframeHeight < height ? iframeHeight : height;
                } else {
                  scope.height = iframeHeight;
                }
              },
              false
            );

            patientsModal = $modal({
              scope,
              prefixClass: 'telesurvey-modal modal',
              contentTemplate: patientsModalTemplateUrl,
            });
            scope.$on('modal.hide', () => {
              $window.removeEventListener('message', onSubmit);
              if (!this.respondSent) {
                this.sendTo(getDoctorUuid(), 'respond', {
                  status: 'cancelled',
                });
              }
            });
          },

          onResponse(message) {
            doctorsScope.status = 'done';
            doctorsScope.result = message.form;

            // Not able to show the survey result for now
            // So jut hiding the modal
            $timeout(() => doctorsModal && doctorsModal.hide(), 3000);
          },

          onFormSubmit(event) {
            const origin = event.origin || event.originalEvent.origin;
            const action = _.get(event, 'data.action');
            const status = _.get(event, 'data.status');

            if (action !== 'doxyme-redcap' || origin !== apiUrl) {
              return;
            }

            if (status === 'filled') {
              responseForm = _.get(event, 'data.form');
            }

            if (status === 'submitted') {
              this.sendTo(getDoctorUuid(), 'respond', {
                status: 'success',
                form: responseForm,
              });
              this.respondSent = true;
              responseForm = null;
              $timeout(() => patientsModal && patientsModal.hide(), 3000);
            }
          },

          reset() {
            this.hideModal();
            if (this.innerMediator) this.innerMediator.removeAllListeners();
            if (this.$scope) this.$scope.$destroy();
            this.$scope = this.target = this.innerMediator = null;
          },
        },
      }).compose(RealtimeComponent);
    }
  ).name;
